import { createContext } from "react";

export const TabsProvider = createContext();
